import { QueryClient, QueryClientProvider } from 'react-query'
import { BrowserRouter, Switch } from 'react-router-dom'
import { AuthProvider } from './core/components'
import { Routes } from './routes/routes'

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false
    }
  }
})

function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <AuthProvider>
        <BrowserRouter>
          <Switch>
            <Routes />
          </Switch>
        </BrowserRouter>
      </AuthProvider>
    </QueryClientProvider>
  )
}

export default App
